import { gql } from '@apollo/client';

const sendPasswordToAgentQuery = gql`
  mutation ($agentID: String!) {
    SendPasswordToAgent(agentID: $agentID)
  }
`;
export default sendPasswordToAgentQuery;
